import React from 'react'

import {
  FormMessageStyled,
  FormMessageIconStyled,
  FormMessageHeadingStyled,
  FormMessageDescriptionStyled,
  FormMessageFooterStyled,
  FormMessageButtonStyled,
  FormMessageCaptionStyled,
  FormMessageCloseStyled
} from './styles'
import Button from './../../atoms/Button'
import { IconSuccessMsg, IconErrorMsg, IconClose } from './../../../assets/svg/index'
import { FormMessageProps } from './types'

const FormMessage: React.FC<FormMessageProps> = ({ isSuccess, heading, description, button, caption, clickHandler, stopPropagation }) => {
  return (
    <FormMessageStyled onClick={stopPropagation}>
      <FormMessageCloseStyled onClick={clickHandler}>
        <IconClose />
      </FormMessageCloseStyled>
      <FormMessageIconStyled>{isSuccess ? <IconSuccessMsg /> : <IconErrorMsg />}</FormMessageIconStyled>
      {heading && (
        <FormMessageHeadingStyled
          as="p"
          sx={{
            color: isSuccess ? 'green' : 'red'
          }}
        >
          {heading}
        </FormMessageHeadingStyled>
      )}
      {description && <FormMessageDescriptionStyled as="p">{description}</FormMessageDescriptionStyled>}
      <FormMessageFooterStyled>
        {button && (
          <FormMessageButtonStyled>
            <Button variant="withArrow" {...button} />
          </FormMessageButtonStyled>
        )}
        {caption && <FormMessageCaptionStyled>{caption}</FormMessageCaptionStyled>}
      </FormMessageFooterStyled>
    </FormMessageStyled>
  )
}

export default FormMessage
